/**
 * OfflineEmptyScreen — Planned: PWA Offline (cold-load fallback), NOT yet wired in.
 *
 * This full-screen "Keine Verbindung / Wiederholen" state is intentionally not
 * rendered on the *runtime* offline path (connection drops while the app is
 * running): there the already-loaded dashboard stays usable, so a full-screen
 * replace would hide usable content. The runtime path is handled by the
 * non-destructive inline offline banners (see useOnlineStatus()).
 *
 * This component becomes relevant only with the PWA-Offline work package — when
 * a Service Worker serves the cached app shell on a *cold* offline load and we
 * need a graceful fallback if no cached data is available. Until then it is
 * deliberately unused, kept ready for that chunk.
 *
 * Decision: Issue #491 (Variante B). Wired up by the full-offline work in
 * issue #570 ("Offline-Fähigkeit IndexedDB / vollständig", Low). Do not treat
 * as dead code.
 */

const WifiOffIcon = () => (
  <svg
    aria-hidden="true"
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="mb-4 text-gray-300"
  >
    <path
      d="M6 6L42 42"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
    />
    <path
      d="M24 36a2 2 0 1 1 0 4 2 2 0 0 1 0-4z"
      fill="currentColor"
    />
    <path
      d="M16.5 28.5C18.9 26.1 22.3 24.7 24 24.7"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
      strokeDasharray="4 3"
    />
    <path
      d="M9 21C13.1 16.9 18.3 14.5 24 14.5c5.7 0 10.9 2.4 15 6.5"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
      strokeDasharray="4 3"
    />
    <path
      d="M3 15C8.6 9.4 15.9 6 24 6c8.1 0 15.4 3.4 21 9"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
      strokeDasharray="4 3"
    />
  </svg>
);

const OfflineEmptyScreen = ({ onRetry }) => (
  <div className="flex flex-col items-center justify-center min-h-[60vh] px-6 text-center">
    <WifiOffIcon />
    <h2 className="text-lg font-semibold text-gray-900 mb-2">Keine Verbindung</h2>
    <p className="text-sm text-gray-500 mb-6">
      Prüfe deine Internetverbindung und versuche es erneut.
    </p>
    <button
      onClick={onRetry}
      className="bg-emerald-600 text-white text-sm px-5 py-2 rounded-lg hover:bg-emerald-700 transition-colors"
    >
      Wiederholen
    </button>
  </div>
);

export default OfflineEmptyScreen;
